import { Options } from '../../common/types'

// option values = translation message id

export const visibilityOptions: Options = {
  options: {
    open: 'towingOrder.visibility_open',
    restricted: 'towingOrder.visibility_restricted',
    assigned: 'towingOrder.visibility_assigned',
  },
}

export const serviceTypeOptions: Options = {
  options: {
    towing: 'towing.servicetype_towing',
    road_service: 'towing.servicetype_road_service',
    other: 'towing.servicetype_other',
    // battery_service: 'towing.servicetype_battery_service',
    // phone_service: 'towing.servicetype_phone_service',
  },
}
